import { FC } from 'react';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FAIcon, IconStyle } from '../../Icons';
import { Theme } from '../../types/enums';
import { SummaryPaneAlertsProps } from './types/propTypes';
import { AlertsType, TextLinkStyle } from './types/enums';
import styles from './SummaryPaneAlerts.module.scss';

function filterIconTheme(theme?: Theme) {
  if (theme === Theme.ACTION) {
    return Theme.PURPLE;
  }
  return theme;
}
function getIcon(type: AlertsType) {
  let iconName: IconName;
  let theme: Theme;
  switch (type) {
    case AlertsType.WARNING:
      iconName = 'triangle-exclamation';
      theme = Theme.WARNING;
      break;
    case AlertsType.INFO:
      iconName = 'info-circle';
      theme = Theme.BLUE;
      break;
    case AlertsType.ACTION:
      iconName = 'bolt';
      theme = Theme.ACTION;
      break;
    case AlertsType.ERROR:
    default:
      iconName = 'square-exclamation';
      theme = Theme.ERROR;
  }
  return {
    iconName,
    theme,
  };
}

export const SummaryPaneAlerts: FC<SummaryPaneAlertsProps> = (props: SummaryPaneAlertsProps) => {
  const { alertType, content, textLinkStyle = TextLinkStyle.UNDERLINE } = props;
  const alert = getIcon(alertType);
  return (
    <div className={styles['container']} data-testid="alert-container">
      <span
        className={`${alert.theme ? styles['icon-container'] : ''} ${styles['icon-selector']} ${
          alert.theme ? styles[alert.theme] : ''
        }`}
      >
        <FAIcon iconName={alert.iconName} iconStyle={IconStyle.SOLID} theme={filterIconTheme(alert.theme)} />
      </span>
      <div
        className={
          styles[textLinkStyle === TextLinkStyle.UNDERLINE ? 'text-link-underline' : 'text-link-no-decoration']
        }
        data-testid="value-container"
      >
        {content}
      </div>
    </div>
  );
};

export default SummaryPaneAlerts;
export { AlertsType, TextLinkStyle };
export type { SummaryPaneAlertsProps };
